// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"V1-z"};